import getCanJoinLoyalty from './getCanJoinLoyalty'
import { isLuxLoyaltyEnabledInAgentHub } from 'agentHub/selectors/isLuxLoyaltyEnabledInAgentHub'

/**
 * Whether to invite an existing customer to activate Société outside Agent Hub, where agents apply a
 * traveller's Société number rather than joining themselves.
 */
function getCanLoyaltyEnrollExistingUser(state: App.State): boolean {
  return !isLuxLoyaltyEnabledInAgentHub && getCanJoinLoyalty(state)
}

export default getCanLoyaltyEnrollExistingUser
